module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('h2', {
    staticStyle: {
      "width": "550px"
    }
  }, [_vm._v("The North Sea")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-1-taybridge-road"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "aberfeldy-perthshire-scotland"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "calibri",
      "width": "550px",
      "text-align": "center",
      "font-size": "18px"
    }
  }, [_c('em', [_vm._v("Part 1: Taybridge Road")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-family": "calibri",
      "text-align": "center",
      "font-size": "16px"
    }
  }, [_c('em', [_vm._v("Aberfeldy, Perthshire, Scotland")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Taybridge Road extends from the only traffic lights in Aberfeldy to the stone bridge across the River Tay. The road and its bridge were part of a system of four military roads built in the first half of the 18th century by an Anglo-Irish- man, General George Wade. In 1724, Wade reported that, following the rebellion of 1715, still some twelve thousand men were ready to rise in arms and to create trouble in the Highlands and Islands. Therefore the roads and their bridges were built wide and strong enough to take the cannons needed to counter the might of castles and defiant men who refused to comply with the bidding of the government in London.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The straight road is now lined on both sides with Victorian, Late Victorian and Edwardian stone and harled houses with slate roofs, built between the middle of the 19th century and the start of the War to End All Wars: WWI. During WWII, the heavy cast iron fences between the front gardens and road were taken so that tanks could be made from the iron, but the war ended before it could be achieved and the solid symbols of Victorian and Edwardian status were dumped in the North Sea. Now, only the hinged cast iron gates are left to tell us of the loss.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("My wife and I live in the third house from the bridge, opposite the town’s putting green. The harled house has stone-built corners and surrounds to the front door and windows. The dozen terra cotta chimney pots on its high chimneys provide a choice of battlegrounds for the local colony of jackdaws. After we arrived here, more than twenty years ago, we planted birch trees. In their tops now dwell wood pigeons, collared doves, blackbirds and thrushes, whilst coal tits and sparrows occupy the high hedges. The shrubberies on two sides and the stone walls on the others set the garden apart from the world outside.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("There used to be a view from the house, to the northwest, of the stone Black Watch statue that guards the bridge, a stern reminder that the watch-company was created by General Wade to control the unruly Highlands. However, a few years ago, the Perth-based council planted a tree on the edge of the putting green, exactly between our front room window and the statue. As the tree grew and grew, it started to obscure our view of the statue and the snow-capped mountain beyond it: Shiehallion, Scotland’s home of the Fairies.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9e7d50c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0016.vue
// module id = 108
// module chunks = 0